import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { createStoreMessage as createStoreMessageAction } from '../../../../actions/customMessages'
import { Notes } from '../../../../components'

const initialMessage = ''

function CustomMessagesModal({ createStoreMessage, storeCode, t }) {
    const [message, setMessage] = useState(initialMessage)

    const onSubmit = async () => {
        const [ok] = await createStoreMessage(storeCode, message)

        if (ok) {
            setMessage(initialMessage)
        }

        return ok
    }

    return (
        <Notes
            noImage
            onChange={({ target: { value } }) => setMessage(value)}
            onSubmit={onSubmit}
            title={t('device-custom-messages-add-title')}
            value={message}
        />
    )
}

CustomMessagesModal.propTypes = {
    createStoreMessage: PropTypes.func.isRequired,
    storeCode: PropTypes.string,
    t: PropTypes.func.isRequired,
}

CustomMessagesModal.defaultProps = {
    storeCode: null,
}

function mapStateToProps({ content: { channels }, stores: { selectedDevice, selectedStore } }) {
    return {
        channels,
        selectedDevice,
        selectedStore,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createStoreMessage: createStoreMessageAction,
        },
        dispatch
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomMessagesModal))
